// Dublettenansicht (Runde 7, Agent 7C; L21, AU-04): Gruppen mit gleichem Namen, gleicher Nummer, E-Mail-Adresse oder Webseite, mit
// Vorschau und Zusammenführen, "keine Dublette" merken und dem Protokoll aller Zusammenführungen. Der Menüpunkt erscheint nur mit dem
// Recht `leads_zusammenfuehren`. Der Filter steht in der Adresse (`?art=telefon&tab=protokoll`), damit Zurück und Neuladen ihn behalten.
import { useSearchParams } from "react-router-dom";
import type { DublettenArt } from "../api/dubletten";
import { useAuth } from "../auth/AuthContext";
import { useSeitenKopf } from "../daten/seite";
import { T } from "../texte";
import { GruppenListe } from "./GruppenListe";
import { ProtokollListe } from "./ProtokollListe";
import { ART_FILTER, TX } from "./texte";
import "./dubletten.css";

export function DublettenStart() {
  useSeitenKopf([{ label: T.nav.dubletten }]);
  const { nutzer } = useAuth();
  const [params, setParams] = useSearchParams();
  const reiter = params.get("tab") === "protokoll" ? "protokoll" : "gruppen";
  const art = (ART_FILTER.find((f) => f.id === params.get("art"))?.id ?? "alle") as DublettenArt;
  const ignorierte = params.get("ignorierte") === "1";

  const setze = (aenderung: Record<string, string | null>) => {
    const neu = new URLSearchParams(params);
    for (const [k, v] of Object.entries(aenderung)) {
      if (v === null) neu.delete(k);
      else neu.set(k, v);
    }
    setParams(neu, { replace: true });
  };

  if (nutzer && !nutzer.permissions.includes("leads_zusammenfuehren")) {
    return (
      <div className="seite dub-seite">
        <h1>{TX.seiteTitel}</h1>
        <p className="dub-text">Für das Zusammenführen von Leads fehlt dir das Recht. Frag Dilsar.</p>
      </div>
    );
  }

  return (
    <div className="seite dub-seite">
      <div className="dub-kopf">
        <h1>{TX.seiteTitel}</h1>
      </div>
      <p className="dub-text">{TX.seiteText}</p>
      <div className="reiter" role="tablist" aria-label="Dubletten">
        {[
          { id: "gruppen", titel: TX.reiterGruppen },
          { id: "protokoll", titel: TX.reiterProtokoll },
        ].map((r) => (
          <button
            key={r.id}
            type="button"
            role="tab"
            aria-selected={reiter === r.id}
            className={`reiter__knopf${reiter === r.id ? " reiter__knopf--an" : ""}`}
            onClick={() => setze({ tab: r.id === "gruppen" ? null : r.id })}
          >
            {r.titel}
          </button>
        ))}
      </div>
      {reiter === "gruppen" ? (
        <GruppenListe
          art={art}
          ignorierte={ignorierte}
          onArt={(a) => setze({ art: a === "alle" ? null : a })}
          onIgnorierte={(an) => setze({ ignorierte: an ? "1" : null })}
        />
      ) : (
        <ProtokollListe />
      )}
    </div>
  );
}
